import { Plan, PlanClient, MSGTYPE } from './plan';

export interface IAppContext {
    action: APP_ACTION;
    actionDispatchedBy: string;
    actionHistory: string[];
    LegalEntityID: string;
    LegalEntityName: string;    
    PlanId: string;
    PlanName: string;
    Clients: PlanClient[];
    Account: string[];
    SelectedAccounts: any[];            
    SelectedExternalAccounts: any[];
    SelectedLiabilities: string[];        
    SelectedExternalLiabilities: string[];        
  }
  
  export enum APP_ACTION{
    'NONE' = 'NONE',
    'RESET' = 'RESET',
    'CLIENT' = 'CLIENT', 
    'SECCLIENT' = 'SECCLIENT', 
    'ACCOUNT' = 'ACCOUNT',
    'SELECTEDACCOUNTS' = 'SELECTEDACCOUNTS',
    'SELECTEDLIABILITIES' = 'SELECTEDLIABILITIES',
    'PLAN' = 'PLAN',
    'INFLIGHTPLAN' = 'INFLIGHTPLAN'    
  }

  export interface IAppData {
    action: DATA_ACTION;
    actionDispatchedBy: string;
    actionHistory: string[];
    Plan: Plan;
    //GoalAnalysis: string;
    GoalSummary: any[];
    GoalSummaryAppliedPlan: any;
    LifeEvents: any;    
    PlanAnalysis: any;
    Clients: any;
    Households: any;
    Accounts: any;  
    ExternalAccounts: any;  
  }

  export enum DATA_ACTION{
    'NONE' = 'NONE',
    'RESET' = 'RESET',
    'RESETRESULTS' = 'RESETRESULTS',
    'CLIENTS' = 'CLIENTS',
    'UPDATECLIENT' = 'UPDATECLIENT',
    'ACCOUNTS' = 'ACCOUNTS',
    'EXTERNALACCOUNTS' = 'EXTERNALACCOUNTS',
    'PLAN' = 'PLAN',
    'INFLIGHTPLAN' = 'INFLIGHTPLAN',
    'PLANIDNAME' = 'PLANIDNAME',
    'CREATEGOAL' = 'CREATEGOAL',
    'SELECTEDPLANACCOUNTS' = 'SELECTEDPLANACCOUNTS',
    'SELECTEDPLANLIABILITIES' = 'SELECTEDPLANLIABILITIES',
    'SELECTEDPLANCLIENT' = 'SELECTEDPLANCLIENT',
    'SELECTEDEXPENSES' = 'SELECTEDEXPENSES',
    'SELECTEDINCOME' = 'SELECTEDINCOME',
    'ADDEXPENSE' = 'ADDEXPENSE',
    'UPDATEEXPENSE' = 'UPDATEEXPENSE',
    'DELETEEXPENSE' = 'DELETEEXPENSE',
    'ADDINCOME' = 'ADDINCOME',
    'UPDATEINCOME' = 'UPDATEINCOME',
    'DELETEINCOME' = 'DELETEINCOME',
    'ADDSAVING' = 'ADDSAVING',
    'UPDATESAVING' = 'UPDATESAVING',
    'DELETESAVING' = 'DELETESAVING',
    'GOALANALYSIS' = 'GOALANALYSIS',
    'GOALSUMMARY' = 'GOALSUMMARY',
    'PLANANALYSIS' = 'PLANANALYSIS',
    'UPDATEPLANRESULTVIEWBY' = 'UPDATEPLANRESULTVIEWBY',
    'UPDATESETTINGS' = 'UPDATESETTINGS'

  }

  export interface IUIState {
    action: UI_STATE_ACTION;    
    actionDispatchedBy: string;
    actionHistory: string[];
    ShowProgressBar: boolean;   
    ShowMsg: boolean;  
    MsgType: MSGTYPE;
    Msg: string;
    Refresh: boolean;
    //IsPlanDirty: boolean;
  }
  
  export enum UI_STATE_ACTION{
    'NONE' = 'NONE',  
    'RESET' = 'RESET',
    'SHOWPROGRESSBAR' = 'SHOWPROGRESSBAR',
    'SHOWERRORMSG' = 'SHOWERRORMSG',
    'REFRESH' = 'REFRESH',
    'PLANDIRTY' = 'PLANDIRTY'
  }

  export interface IRefData {
    action: REF_DATA_ACTION;
    actionDispatchedBy: string;
    actionHistory: string[];
    StateExpense: string;
    KeyValue: any;
    LifeExpectancy: any;    
    PlanningUI: any;
    AccType: any;
  }

  export enum REF_DATA_ACTION{
    'NONE' = 'NONE',
    'RESET' = 'RESET',
    'KEYVALUE' = 'KEYVALUE',
    'STATEEXP' = 'STATEEXP',
    'LIFEEXPECTANCY' = 'LIFEEXPECTANCY',
    'PLANNINGUI' = 'PLANNINGUI',
    'ACCTYPE' = 'ACCTYPE'
  }

  export interface IChartData {
    action: CHART_DATA_ACTION;
    actionDispatchedBy: string;
    actionHistory: string[];
    ChartSeries: any[];
  }

  export enum CHART_DATA_ACTION{
    'NONE' = 'NONE',
    'RESET' = 'RESET',
    'CHARTSERIES' = 'CHARTSERIES'    
  }

  


  